import { ArrowNavRightIcon } from "@bookingcom/bui-assets-react/streamline";
import { Card, HiddenVisually, Icon, ListItem, Text } from "@bookingcom/bui-react";
import useGlobalContext from "../../../hooks/useGlobalContext";
import React from "react";
import flights_web_flight_card_update_desktop from "../../../utils/experiments/funnel/flights_web_flight_card_update_desktop";
import useRouteName from "../../../hooks/useRouteName";
import useProfiler from "../../../hooks/useProfiler";

const id = "dsa_label_descr";

const DSABannerDesktop = () => {
  const { contentStandardsGuidelines } = useGlobalContext();
  const routeName = useRouteName();
  const { isDesktop } = useProfiler();

  if (!contentStandardsGuidelines) {
    isDesktop() && flights_web_flight_card_update_desktop.stages.dsa_banner_unavailable();
    return undefined;
  }

  isDesktop() && flights_web_flight_card_update_desktop.stages.users_see_dsa_banner();
  routeName === "fly-anywhere" &&
    isDesktop() &&
    flights_web_flight_card_update_desktop.stages.users_see_dsa_banner_fly_anywhere();

  return (
    <Card fill>
      <ListItem
        attributes={{
          target: "_blank",
          "data-testid": "DSABanner_link",
          "aria-describedby": id
        }}
        href={contentStandardsGuidelines.linkUrl}
        endSlot={<Icon svg={ArrowNavRightIcon} size="medium" />}
        onClick={() => flights_web_flight_card_update_desktop.goals.dsa_banner_click()}
      >
        <Text>{contentStandardsGuidelines.message}</Text>
      </ListItem>
      <HiddenVisually>
        <div id={id}>{contentStandardsGuidelines.linkLabel}</div>
      </HiddenVisually>
    </Card>
  );
};

export default DSABannerDesktop;
